import { request } from '@utils';

const instapaymentReport = async () => {
  const body = {
    body: {
      type: 'csv',
      rule: {
        type: 2,
      },
    },
  };
  const results = await request.post(
    `/v1/reports/instapayment/export/async`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const avisReport = async (months) => {
  const params = {
    months,
    responseType: 'arraybuffer',
  };
  const results = await request.get(`/v1/reports/avis`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const arnmSLAReport = async () => {
  const body = {
    body: {
      type: 'csv',
      rule: {
        type: 2,
      },
    },
  };
  const results = await request.post(`/v1/reports/arnm/export/async`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export { instapaymentReport, avisReport, arnmSLAReport };
